import React, { forwardRef, useMemo } from 'react'

import FormattedInput, { BaseFormattedInputProps } from '../Arcade/Input/FormattedInput'

const DIGIT_PLACEHOLDER = '#'
const DIGIT_SEPARATOR = '-'
const DIGITS_PER_GROUP = 3

export interface ConfirmationCodeInputProps extends BaseFormattedInputProps {
  maxDigits?: number
  isFormatted?: boolean
}

const ConfirmationCodeInput = forwardRef<HTMLInputElement, ConfirmationCodeInputProps>(
  ({ maxDigits = 6, isFormatted = true, value, ...restProps }, ref) => {
    const template = useMemo(() => {
      if (!isFormatted) return DIGIT_PLACEHOLDER.repeat(maxDigits)

      const parts = []
      for (let i = 0; i < maxDigits; i += DIGITS_PER_GROUP) {
        const remaining = Math.min(DIGITS_PER_GROUP, maxDigits - i)
        parts.push(DIGIT_PLACEHOLDER.repeat(remaining))
      }
      return parts.join(DIGIT_SEPARATOR)
    }, [isFormatted, maxDigits])

    return <FormattedInput ref={ref} value={value} template={template} {...restProps} />
  }
)

ConfirmationCodeInput.displayName = 'ConfirmationCodeInput'

export default ConfirmationCodeInput
